import { render } from "./SingleSelection.vue?vue&type=template&id=5a632522"
import script from "./SingleSelection.vue?vue&type=script&lang=js"
export * from "./SingleSelection.vue?vue&type=script&lang=js"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__